var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMod1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 861.96 248.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2731b8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.26,514.79,100,391.14H241.31v43.5H145.52l-5.48,48a66.46,66.46,0,0,1,15.69-6.16,71.55,71.55,0,0,1,19-2.67q36,0,55.37,21.33T249.45,555q0,23.25-10.38,42.08a71.26,71.26,0,0,1-29.14,29q-18.75,10.13-44.32,10.13a99.08,99.08,0,0,1-42.67-9.37Q103,617.43,91.73,601.1a62.48,62.48,0,0,1-11.12-36.91h56.11q.83,13.24,8.47,21T165.28,593q28.22,0,28.22-41.75,0-38.61-34.53-38.61-19.59,0-29.22,12.6Z",
    transform: "translate(-80.61 -387.82)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.67,534.08q0,49-22,75.54t-62,26.56q-40.35,0-62.42-26.73t-22.08-75.37V489.92q0-49,22-75.54t62.18-26.56q40.17,0,62.25,26.73t22.08,75.54Zm-55.94-51.3q0-26.05-6.81-38.93T362.34,431q-14.44,0-21,12t-7.06,36.19v61.76q0,27.06,6.81,39.59T362.67,593q14.28,0,21.08-12.21t7-38.26Z",
    transform: "translate(-80.61 -387.82)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M511.42,446.09q13.27,0,22.08,7.89a27.52,27.52,0,0,1,0,40.34q-8.81,7.89-22.08,7.89-13.46,0-22.16-8a27.5,27.5,0,0,1,0-40.18Q498,446.1,511.42,446.09Zm0,132.48q13.27,0,22.08,7.89a27.52,27.52,0,0,1,0,40.34q-8.81,7.89-22.08,7.89-13.46,0-22.16-8a27.5,27.5,0,0,1,0-40.18Q498,578.58,511.42,578.57Z",
    transform: "translate(-80.61 -387.82)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M581.15,514.79l14.77-123.65H737.2v43.5H641.41l-5.48,48a66.29,66.29,0,0,1,15.69-6.16,71.5,71.5,0,0,1,19-2.67q36,0,55.36,21.33T745.33,555q0,23.25-10.37,42.08a71.26,71.26,0,0,1-29.14,29q-18.75,10.13-44.32,10.13a99.08,99.08,0,0,1-42.67-9.37q-19.92-9.37-31.21-25.71a62.48,62.48,0,0,1-11.12-36.91h56.11q.82,13.24,8.47,21T661.17,593q28.22,0,28.22-41.75,0-38.61-34.53-38.61-19.59,0-29.22,12.6Z",
    transform: "translate(-80.61 -387.82)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M942.56,534.08q0,49-22,75.54t-62,26.56q-40.35,0-62.42-26.73t-22.08-75.37V489.92q0-49,22-75.54t62.18-26.56q40.17,0,62.25,26.73t22.08,75.54Zm-55.95-51.3q0-26.05-6.8-38.93T858.23,431q-14.44,0-21,12t-7.05,36.19v61.76q0,27.06,6.81,39.59T858.56,593q14.28,0,21.08-12.21t7-38.26Z",
    transform: "translate(-80.61 -387.82)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMod1);
export default __webpack_public_path__ + "static/media/Mod1.72698cd0e6a911c4f91e2c6cb93c2ddc.svg";
export { ForwardRef as ReactComponent };